import type { CmsPageFragment } from '~/shared/graphql/content/CmsPageQuery.generated';
import ArticleContent from './ArticleContent';
import ArticleImage from './ArticleImage';
import CmsContent from './CmsContent';
import Content from './Content';
import ContentWrapper from './ContentWrapper';
import RightSideBar from './RightSideBar';
import TableOfContents from './TableOfContents/';
import ButtonClose from './TableOfContents/ButtonClose';
import StyledModal from './TableOfContents/styles/Modal';
import ToggleButton from './TableOfContents/styles/ToggleButton';
import useTableOfContents from './TableOfContents/useTableOfContents';
import TopBlock from './TopBlock';
import type { BlogContentNodeFragment } from '../../../graphql/BlogArticleQuery.generated';
import TextBulletsList from '@/external/icons/TextBulletsList';

type Props = {
  page: BlogContentNodeFragment;
};

const BlogArticleView: FC<Props> = ({ page }) => {
  const { largeImage, mainBlock = '', publishDate = '', title = '' } = page;
  const { tableOfContents, hasModal, showModal, toggleShowModal } =
    useTableOfContents(page);

  return (
    <ArticleContent>
      <ArticleImage src={largeImage} alt={title} lazy={false} />
      <ContentWrapper>
        <Content>
          <TopBlock publishDate={publishDate} title={title} />
          <CmsContent
            content={mainBlock}
            article={page as CmsPageFragment}
            isFixedImgSize
          />
        </Content>
        <RightSideBar tableOfContents={tableOfContents} />
      </ContentWrapper>
      <StyledModal
        isOpen={showModal}
        handleClose={toggleShowModal}
        content={
          <>
            <TableOfContents
              toggleShowModal={toggleShowModal}
              tableOfContents={tableOfContents}
            />
            <ButtonClose handleClose={toggleShowModal} />
          </>
        }
        showAnimation
        clickOutsideClose
      />
      {hasModal && !showModal && (
        <ToggleButton onClick={toggleShowModal}>
          <TextBulletsList fontSize={24} />
        </ToggleButton>
      )}
    </ArticleContent>
  );
};

export default BlogArticleView;
